<template>
  <div class="wrapper-layout">
    <Sidebar />
    <div class="section">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import Sidebar from "./components/Sidebar.vue";


export default defineComponent({
  name: "LayoutAdmin",
  components: { Sidebar },
  setup() {
    return {};
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/admin/layoutAdmin/styles/layoutAdminStyle";
</style>
